import { SwitchField } from "common";
import React from "react";
import { ArrivalError, PurchaseItem, ValidationLevel } from "types";
import { isVariableDemographicsPackage } from "../../models/Package";
import { CreatePurchaseItemState, useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { usePackage } from "@/hooks/usePackage";

interface ArrivalRestrictionsProps {
    item?: PurchaseItem | CreatePurchaseItemState;
    packageId?: string;
    product: ID;
    errors: ArrivalError[];
}

export const ArrivalRestrictions = ({ packageId, item, product, errors }: ArrivalRestrictionsProps) => {
    const firstItem = useCreatePurchaseStore((state) => state.getFirstItem()) ?? item;
    const { pkg: package_ } = usePackage(packageId);

    const hasErrors = errors.length > 0;
    const packagePurchase = !!firstItem?.parentProduct?.id;
    const isFirstItem = product === firstItem?.product.id;

    const shouldIgnoreRestrictions = useCreatePurchaseStore((state) => state.shouldIgnoreRestrictions);
    const handleIgnoreRestriction = (isChecked: boolean) => {
        useCreatePurchaseStore.setState({ shouldIgnoreRestrictions: isChecked });
    };

    const hasPackageErrors = hasErrors && packagePurchase && (isFirstItem || isVariableDemographicsPackage(package_));
    const hasValidationErrors = errors.some((error) => error.level === ValidationLevel.ERROR);

    return (
        <div className="flex w-full justify-between">
            <div className="space-y-0.5">
                {errors.length > 0 &&
                    errors.map((error) => (
                        <div key={error.code}>
                            <span className="text-danger">{error.message}</span>
                        </div>
                    ))}
            </div>
            {hasPackageErrors && !hasValidationErrors && (
                <div className="self-end">
                    <SwitchField size="small" isChecked={shouldIgnoreRestrictions} onChange={handleIgnoreRestriction}>
                        Ignore Restrictions
                    </SwitchField>
                </div>
            )}
        </div>
    );
};
